import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

export const useBiocyclePhases = ({
  fieldId,
  cropId,
  startDate,
  endDate,
  isVisible,
}) => {
  const isEnabled =
    isVisible && !!fieldId && !!cropId && !!startDate && !!endDate;
  const { data, ...restResponse } = useQuery({
    queryKey: ["biocycle-seasons", fieldId, cropId, startDate, endDate],
    queryFn: () =>
      api.biocycle.bioPhases({ fieldId, cropId, startDate, endDate }),
    enabled: isEnabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  const { fetchState } = useFetchStateHelper(restResponse);

  return {
    data,
    fetchState,
  };
};

export const useBiocyclePhasesPopulated = (fieldId) => {
  const { data, ...restResponse } = useQuery({
    queryKey: ["biocycle-phases-stresses", fieldId],
    queryFn: () => api.biocycle.biocyclePhasesStresses(fieldId),
    enabled: !!fieldId,
    staleTime: 3 * 60 * 1000, // 3 minutes
  });

  const { fetchState } = useFetchStateHelper(restResponse);

  return {
    data,
    fetchState,
  };
};
